import { Button, Result } from "antd";
import { nextPage } from "../../util/library/Router";
import { PATHNAME } from "../../util/varibles/constants";
import styles from './style.module.scss';

const NotFoundPage = () => {
    return <Result
        status="500"
        title={<div className={styles.title}>Error page</div>}
        subTitle="Sorry, the page you visited does not exist."
        extra={<div className="flex justify-center">
            <Button className='bt-primary' type="primary" onClick={() => nextPage(PATHNAME.HOME)}>
                Back Dashboard
            </Button>
        </div>}
    />;
}

export default NotFoundPage;
